export default {
  'set_cities': (state, value) => state.cities = value,
  'set_cities_by_state_id': (state, value) => state.cities_by_state_id = value,
}
